module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-1-buyback_fd39c815dc4b9e5dbdd67984267835d9.png";